var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnedrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6074 14.282C8.18677 14.2823 3.38715 19.5524 3.02588 25.4234C3.24968 26.6884 3.98464 29.1863 5.13606 29.0581C6.57509 28.8977 10.1995 29.0581 13.291 23.4463C15.5492 19.347 20.1947 14.2818 14.6074 14.282Z",
    fill: "url(#paint0_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 16.4736C10.965 19.9 8.05963 24.8098 7.0791 26.3548C5.9135 28.1915 2.82684 27.4111 3.08254 24.7789C3.05748 24.9924 3.03799 25.2079 3.02457 25.4247C2.60253 32.2735 8.01786 37.9612 14.7568 37.9612C22.1838 37.9612 39.8969 28.6822 38.1042 19.3849C36.2148 13.9201 30.9045 10.0002 24.8861 10.0002C18.868 10.0002 15.011 13.4768 13.1233 16.4736Z",
    fill: "url(#paint1_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 16.4736C10.965 19.9 8.05963 24.8098 7.0791 26.3548C5.9135 28.1915 2.82684 27.4111 3.08254 24.7789C3.05748 24.9924 3.03799 25.2079 3.02457 25.4247C2.60253 32.2735 8.01786 37.9612 14.7568 37.9612C22.1838 37.9612 39.8969 28.6822 38.1042 19.3849C36.2148 13.9201 30.9045 10.0002 24.8861 10.0002C18.868 10.0002 15.011 13.4768 13.1233 16.4736Z",
    fill: "url(#paint2_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 16.4736C10.965 19.9 8.05963 24.8098 7.0791 26.3548C5.9135 28.1915 2.82684 27.4111 3.08254 24.7789C3.05748 24.9924 3.03799 25.2079 3.02457 25.4247C2.60253 32.2735 8.01786 37.9612 14.7568 37.9612C22.1838 37.9612 39.8969 28.6822 38.1042 19.3849C36.2148 13.9201 30.9045 10.0002 24.8861 10.0002C18.868 10.0002 15.011 13.4768 13.1233 16.4736Z",
    fill: "url(#paint3_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 16.4736C10.965 19.9 8.05963 24.8098 7.0791 26.3548C5.9135 28.1915 2.82684 27.4111 3.08254 24.7789C3.05748 24.9924 3.03799 25.2079 3.02457 25.4247C2.60253 32.2735 8.01786 37.9612 14.7568 37.9612C22.1838 37.9612 39.8969 28.6822 38.1042 19.3849C36.2148 13.9201 30.9045 10.0002 24.8861 10.0002C18.868 10.0002 15.011 13.4768 13.1233 16.4736Z",
    fill: "url(#paint4_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 16.4736C10.965 19.9 8.05963 24.8098 7.0791 26.3548C5.9135 28.1915 2.82684 27.4111 3.08254 24.7789C3.05748 24.9924 3.03799 25.2079 3.02457 25.4247C2.60253 32.2735 8.01786 37.9612 14.7568 37.9612C22.1838 37.9612 39.8969 28.6822 38.1042 19.3849C36.2148 13.9201 30.9045 10.0002 24.8861 10.0002C18.868 10.0002 15.011 13.4768 13.1233 16.4736Z",
    fill: "url(#paint5_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6479 37.964C14.6479 37.964 32.3818 37.999 35.39 37.999C40.8489 37.999 44.9994 33.5303 44.9994 28.3156C44.9994 23.1008 40.7653 18.6593 35.39 18.6593C30.0144 18.6593 26.9186 22.6916 24.5935 27.0935C21.8691 32.2514 18.3934 37.9023 14.6479 37.964Z",
    fill: "url(#paint6_linear_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6479 37.964C14.6479 37.964 32.3818 37.999 35.39 37.999C40.8489 37.999 44.9994 33.5303 44.9994 28.3156C44.9994 23.1008 40.7653 18.6593 35.39 18.6593C30.0144 18.6593 26.9186 22.6916 24.5935 27.0935C21.8691 32.2514 18.3934 37.9023 14.6479 37.964Z",
    fill: "url(#paint7_radial_457_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6479 37.964C14.6479 37.964 32.3818 37.999 35.39 37.999C40.8489 37.999 44.9994 33.5303 44.9994 28.3156C44.9994 23.1008 40.7653 18.6593 35.39 18.6593C30.0144 18.6593 26.9186 22.6916 24.5935 27.0935C21.8691 32.2514 18.3934 37.9023 14.6479 37.964Z",
    fill: "url(#paint8_radial_457_533)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.48159 10.1904 -16.8569 14.1065 3.82221 15.8207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4894FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695072,
    stopColor: "#0934B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-37.2856 43.1255 -31.8698 -27.7039 39.3581 0.5391)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165327,
    stopColor: "#23C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#1C91FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.86323 -7.46104 17.0336 -20.3449 12.412 16.5765)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660528,
    stopColor: "#ADC0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.95758 -8.44842 12.796 -15.1638 24.9957 30.2915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.38 26.3329 -28.3509 12.3188 11.646 9.11551)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.592618,
    stopColor: "#3464E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033ACC",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.77 29.8508 -46.6395 -46.7662 38.8993 3.51975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BFDE8",
    stopOpacity: 0.898039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543937,
    stopColor: "#4BFDE8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_457_533",
    x1: 29.8331,
    y1: 37.9795,
    x2: 29.8331,
    y2: 18.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00BBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.7339 7.05207 -13.3181 33.6733 19.884 20.9336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785262,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_457_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.8119 17.1216 -17.1332 -19.9331 44.4061 17.1602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BFDE8",
    stopOpacity: 0.898039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584724,
    stopColor: "#4BFDE8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 28,
    fill: "white",
    transform: "translate(3 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.aaf108974303b1722b28a35bbd1b6f09.svg";
export { ForwardRef as ReactComponent };